<template>
    <vx-badge :color="config.color" size="xs">
        {{ config.label }}
        <font-awesome-icon widthAuto :icon="config.icon" />
    </vx-badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPenRuler, faCheck, faPause, faOctagon } from '@fortawesome/pro-solid-svg-icons';
import { VxBadge } from '@voxie/frontend-components';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { GroupStatus } from '~/constants/groupStatuses';

const statusConfig: Record<GroupStatus, { label: string; icon: IconDefinition; color: 'amber' | 'sky' | 'rose' | 'slate' }> = {
    draft: {
        label: 'Draft',
        icon: faPenRuler,
        color: 'amber',
    },
    active: {
        label: 'Active',
        icon: faCheck,
        color: 'sky',
    },
    suspended: {
        label: 'Suspended',
        icon: faPause,
        color: 'rose',
    },
    closed: {
        label: 'Closed',
        icon: faOctagon,
        color: 'slate',
    },
};

const props = defineProps<{
    status: GroupStatus;
}>();

const config = computed(() => statusConfig[props.status]);
</script>
